import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google'
import 'bootstrap/dist/css/bootstrap.min.css'

import StockerLayout from 'pages/StockerLayout'
import Login from 'pages/Login'
import DailyInfo from 'pages/DailyInfo'
import Revenue from 'pages/Revenue'
import Eps from 'pages/Eps'
import IncomeSheet from 'pages/IncomeSheet'
import ProfitAnalysis from 'pages/ProfitAnalysis'
import OperatingExpensesAnalysis from 'pages/OperatingExpensesAnalysis'
import MonthlyValuation from 'pages/MonthlyValuation'
import MarketNews from 'pages/taiwan_market/MarketNews'
import AnnouncementDismantling from 'pages/taiwan_market/AnnouncementDismantling'
import AnnouncementDismantlingList from 'pages/taiwan_market/AnnouncementDismantlingList'
import StockFeed from 'pages/StockFeed'
import RecommendStockList from 'pages/RecommendStockList'
import EarningsCallList from 'pages/EarningsCallList'
import UserInfo from 'pages/UserInfo'
import FollowStockList from 'pages/FollowStockList'
import AdminUserManagement from 'pages/AdminUserManagement'
import AiPromptManager from 'pages/AiPromptManager'
import AiApiKeyManager from 'pages/AiApiKeyManager'
import AiUsageReport from 'pages/AiUsageReport'
import AiReportList from 'pages/AiReportList'
import AdminSettings from 'pages/AdminSettings'
import StockEarningsCall from 'pages/StockEarningsCall'
import RequireAuth from 'components/RequireAuth'

export default function App () {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            exact path="/login"
            element={<Login />}
          />
          <Route element={<RequireAuth />}>
            <Route
              path="/"
              element={
                <StockerLayout />
              }
            >
              {['/', '/basic-info/daily-info/:stockNum'].map(path => (
                <Route
                  key={path}
                  exact
                  path={path}
                  element={<DailyInfo />}
                />
              ))}
              <Route
                path="/basic-info/company-data/:stockNum"
                element={<p>company data</p>}
              />
              <Route
                key="news"
                path="/basic-info/news/:stockNum"
                element={<StockFeed />}
              />
              <Route
                key="comment"
                path="/basic-info/comment/:stockNum"
                element={<p>comment</p>}
              />
              <Route
                key="earnings-call"
                path="/basic-info/earnings-call/:stockNum"
                element={<StockEarningsCall />}
              />
              <Route
                key="revenue"
                path="/financial-stat/revenue/:stockNum"
                element={<Revenue />}
              />
              <Route
                key="eps"
                path="/financial-stat/eps/:stockNum"
                element={<Eps />}
              />
              <Route
                key="income-sheet"
                path="/financial-stat/income-sheet/:stockNum"
                element={<IncomeSheet />}
              />
              <Route
                key="profit-analysis"
                path="/financial-stat/profit-analysis/:stockNum"
                element={<ProfitAnalysis />}
              />
              <Route
                key="operating-expenses-analysis"
                path="/financial-stat/operating-expenses-analysis/:stockNum"
                element={<OperatingExpensesAnalysis />}
              />
              <Route
                key="monthly-valuation"
                path="/valuation/monthly-valuation/:metric/:stockNum"
                element={<MonthlyValuation />}
              />
              <Route path="*" element={<p>no match</p>} />
            </Route>
            <Route
              path=""
              element={
                <StockerLayout />
              }
            >
              <Route
                key="market-news"
                path="/taiwan-stock/news"
                element={<MarketNews />}
              />
              <Route
                key="announcement-dismantling"
                path="/taiwan-stock/announcement-dismantling"
                element={<AnnouncementDismantling />}
              />
              <Route
                key="announcement-dismantling-list"
                path="/taiwan-stock/announcement-dismantling-list"
                element={<AnnouncementDismantlingList />}
              />
              <Route
                key="recommend-stock"
                path="/taiwan-stock/recommend-stock"
                element={<RecommendStockList />}
              />
              <Route
                key="earnings-call-list"
                path="/taiwan-stock/earnings-call"
                element={<EarningsCallList />}
              />
            </Route>
            <Route
              path=""
              element={
                <StockerLayout />
              }
            >
              <Route
                key="user-info"
                path="/user"
                element={<UserInfo />}
              />
              <Route
                key="follow-stock-list"
                path="/user/follow-stocks"
                element={<FollowStockList />}
              />
              <Route
                key="admin-user-management"
                path="/admin/users"
                element={<AdminUserManagement />}
              />
              <Route
                key="admin-ai-prompts"
                path="/admin/ai-prompts"
                element={<AiPromptManager />}
              />
              <Route
                key="admin-ai-api-keys"
                path="/admin/ai-api-keys"
                element={<AiApiKeyManager />}
              />
              <Route
                key="admin-ai-report"
                path="/admin/ai-report"
                element={<AiReportList />}
              />
              <Route
                key="admin-ai-usage-report"
                path="/admin/ai-usage-report"
                element={<AiUsageReport />}
              />
              <Route
                key="admin-settings"
                path="/admin/settings"
                element={<AdminSettings />}
              />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
    </GoogleOAuthProvider>
  )
}
